import { render, staticRenderFns } from "./WorkProject.vue?vue&type=template&id=37f3ae9e"
import script from "./WorkProject.vue?vue&type=script&lang=js"
export * from "./WorkProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports